import { Box, BoxProps } from '@mui/material';

type Props = {
    vertical?: any;
    horizontal?: any;
    top?: any;
    bottom?: any;
    border?: any;
} & BoxProps;

const Spacing = ({
    vertical,
    horizontal,
    top,
    bottom,
    border,
    ...props
}: Props) => {
    return (
        <Box
            sx={{
                marginY: (vertical || 0) * 8,
                marginX: (horizontal || 0) * 8,
                borderBottom: theme => (border ? `1px solid ${theme.palette.divider}` : undefined),
                marginBottom: bottom ? bottom * 8 : undefined,
                marginTop: top ? top * 8 : undefined,
            }}
            {...props}
        />
    );
};
export default Spacing;
